import type { BadgeSentiment } from '@sequencehq/core-components'
import type { XeroMonthSyncState } from './deriveMonthSyncState'

export const XERO_SYNC_STATE_LABEL: Record<XeroMonthSyncState, string> = {
  PUSHING: 'Syncing',
  FAILED: 'Failed',
  STALE: 'Changed',
  NOT_SYNCED: 'Not synced',
  SYNCED: 'Synced'
}

// Badge colours matched to the semantic icon palette:
// green = synced, indigo = syncing, amber = changed, grey = not synced, red = failed.
export const XERO_SYNC_STATE_SENTIMENT: Record<
  XeroMonthSyncState,
  BadgeSentiment
> = {
  SYNCED: 'success',
  PUSHING: 'info',
  STALE: 'warning',
  NOT_SYNCED: 'neutral',
  FAILED: 'error'
}

export const XERO_SYNC_TEST_IDS = {
  /** Suffix with the yyyy-MM month key, e.g. `revrec.xeroSync.badge.2026-06`. */
  badge: 'revrec.xeroSync.badge'
} as const
